import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LogiWorkLandingSolution() {
  const [currentHash, setCurrentHash] = useState("smartCooperation");
  const { t } = useTranslation();

  const solutions = [
    {
      key: "smartCooperation",
      nav_title: t("logiWorkLanding.solution.smartCooperation.navTitle"),
      title: t("logiWorkLanding.solution.smartCooperation.title"),
      sub_title: "Smart Cooperation",
      desc: t("logiWorkLanding.solution.smartCooperation.desc"),
      img: "smartCooperation.png",
      img_alt: t("logiWorkLanding.solution.smartCooperation.imgAlt"),
      img_order: 1,
    },
    {
      key: "workEfficiency",
      nav_title: t("logiWorkLanding.solution.workEfficiency.navTitle"),
      title: t("logiWorkLanding.solution.workEfficiency.title"),
      sub_title: "Upgrading Work Efficiency",
      desc: t("logiWorkLanding.solution.workEfficiency.desc"),
      img: "workEfficiency.png",
      img_alt: t("logiWorkLanding.solution.workEfficiency.imgAlt"),
      img_order: 0,
    },
    {
      key: "mobileSupport",
      nav_title: t("logiWorkLanding.solution.mobileSupport.navTitle"),
      title: t("logiWorkLanding.solution.mobileSupport.title"),
      sub_title: "Smartphone Synchronization",
      desc: t("logiWorkLanding.solution.mobileSupport.desc"),
      img: "mobileSupport.png",
      img_alt: t("logiWorkLanding.solution.mobileSupport.imgAlt"),
      img_order: 1,
    },
  ];

  return (
    <div className="p-3 p-md-5 margin_30">
      <div className="container-xl">
        <p className="BM-DH h2 mb-4 font-weight-bold">
          {t("logiWorkLanding.solution.title")}
        </p>
        <div className="carousel-indicators p-0 m-0 position-static justify-content-center justify-content-md-start h5 mb-5 font-weight-900 ">
          {solutions.map((item, index) => {
            return (
              <p
                key={item.key}
                data-target="#solutionCarousel"
                data-slide-to={index}
                className={`${
                  currentHash === item.key
                    ? "text-freiscop border-bottom border-2 border-freiscop"
                    : ""
                }  cursor_pointer mr-3 text-center`}
                onClick={() => setCurrentHash(item.key)}
              >
                {item.nav_title}
              </p>
            );
          })}
        </div>

        <div
          id="solutionCarousel"
          className="carousel slide flex-fill"
          data-touch="false"
          data-interval="false"
        >
          <div className="carousel-inner">
            {solutions.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`carousel-item ${
                    currentHash === item.key ? "active" : ""
                  }`}
                >
                  <div className="row m-0 p-0 pb-4 pt-md-4">
                    <div
                      className={`col-xl-4 m-0 p-0 d-flex flex-row justify-content-center align-items-center order-xl-${item.img_order}`}
                    >
                      <img
                        className="d-none d-xl-block"
                        style={{ height: 400 }}
                        src={`/img/use_img/${item.img}`}
                        alt={item.img_alt}
                      />
                      <img
                        className="d-none d-md-block mb-3 d-xl-none"
                        style={{ height: 250 }}
                        src={`/img/use_img/${item.img}`}
                        alt={item.img_alt}
                      />
                      <img
                        className="d-block d-md-none mb-3"
                        style={{ height: 120 }}
                        src={`/img/use_img/${item.img}`}
                        alt={item.img_alt}
                      />
                    </div>
                    <div
                      className={`col-xl-8 m-0 p-0 ${
                        item.img_order === 1 ? "pr-xl-3" : "pl-xl-3"
                      } d-flex flex-column justify-content-between`}
                    >
                      <div>
                        <p className="h3 font-weight-900 text-freiscop">
                          {item.title}
                        </p>
                        <p className="h4 text-secondary">{item.sub_title}</p>
                      </div>
                      <p
                        className="h5 pr-xl-5"
                        style={{
                          whiteSpace: "break-spaces",
                          wordBreak: "keep-all",
                          lineHeight: "1.8em",
                        }}
                      >
                        {item.desc}
                      </p>
                      <div className="text-center text-lg-left mt-2">
                        <button
                          className="btn btn-info bg-freiscop border-freiscop"
                          onClick={() => {
                            window.open(
                              "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/mall/notice/20230808110326_230803_%EB%A1%9C%EC%A7%80%EC%9B%8D_%EC%A0%9C%EC%95%88%EC%84%9C.pdf",
                              "_blank",
                              "width=1200, height=800"
                            );
                          }}
                        >
                          {t("logiWorkLanding.solution.introductionMaterial")}
                          <i className="fa-solid fa-download ml-2" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="carousel-control-prev text-secondary bg-transparent d-inline-block border-0 ml-2 ml-md-0"
            type="button"
            style={{
              width: "unset",
              height: "unset",
              left: "-40px",
            }}
            onClick={() => {
              let findInd = solutions.findIndex(
                (item) => item.key === currentHash
              );

              if (findInd > 0) {
                setCurrentHash(solutions[findInd - 1].key);
              } else {
                setCurrentHash(solutions[solutions.length - 1].key);
              }
            }}
          >
            <span className="h1 mb-0">
              <i className="fa-solid fa-chevron-left" />
            </span>
          </button>
          <button
            className="carousel-control-next text-secondary bg-transparent border-0 mr-2 mr-md-0"
            type="button"
            style={{
              width: "unset",
              height: "unset",
              right: "-40px",
            }}
            onClick={() => {
              let findInd = solutions.findIndex(
                (item) => item.key === currentHash
              );
              if (findInd < solutions.length - 1) {
                setCurrentHash(solutions[findInd + 1].key);
              } else {
                setCurrentHash(solutions[0].key);
              }
            }}
          >
            <span className="h1 mb-0">
              <i className="fa-solid fa-chevron-right" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
